<script setup lang="ts">
  import { defineProps, defineEmits, onMounted, ref, computed } from 'vue'
  import EmailPreview from '@/components/app/email/EmailPreview.vue'
  import {
    type EmailRenderTemplateResponse,
    EmailsService,
    type Placeholder
  } from '@/types/generated'
  import { usePlaceholderStore } from '@/shared/stores/placeholderStore'

  const { placeholders, fetchPlaceholders } = usePlaceholderStore()
  const questionnaireAndDocumentsPlaceholder = computed<Placeholder>(() => {
    return placeholders.find((placeholder) => placeholder.key === 'questionnaires_and_documents')
  })
  const props = defineProps({
    templateHtml: {
      type: String,
      required: true
    },
    fromEmail: {
      type: String,
      required: true
    },
    subject: {
      type: String,
      required: true
    }
  })

  const renderedTemplate = ref<EmailRenderTemplateResponse>()

  onMounted(async () => {
    if (placeholders.length === 0) {
      await fetchPlaceholders()
    }
    renderedTemplate.value = await EmailsService.emailsRenderTemplateCreate({
      requestBody: {
        template_html: props.templateHtml,
        subject: props.subject,
        contexts: [
          {
            key: 'questionnaires_and_documents',
            context: questionnaireAndDocumentsPlaceholder.value?.demo_context_dict
          }
        ]
      }
    })
  })
  const emit = defineEmits(['close'])

  const closeModal = () => {
    emit('close')
  }
</script>

<!-- This will will be replaced when the email preview is ready -->
<template>
  <div
    class="fixed inset-0 z-50 overflow-y-auto"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
    v-if="renderedTemplate"
  >
    <div
      class="flex min-h-screen items-end justify-center px-4 pb-20 pt-4 text-center sm:block sm:p-0"
    >
      <div
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
        @click="closeModal"
      ></div>

      <span
        class="hidden sm:inline-block sm:h-screen sm:align-middle"
        aria-hidden="true"
      >
        &#8203;
      </span>

      <div
        class="inline-block transform overflow-hidden rounded-lg bg-white text-left align-bottom shadow-xl
          transition-all sm:my-12 sm:w-full sm:max-w-screen-md sm:align-middle"
      >
        <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
          <div class="">
            <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
              <EmailPreview
                :subject="renderedTemplate.subject"
                recipient-email="max.mustermann@outlook.com"
                :from-email="props.fromEmail"
                :text-html="renderedTemplate.html"
              />
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          <button
            type="button"
            @click="closeModal"
            class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold
              text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
          >
            Vorschau schließen
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
